// src/store/reducers/design/masterDataSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface MasterDataState {
  languageDetails: { languageID: number; languageName: string }[];
  preprocessingDetails: { preProcessingID: number; preProcessingName: string }[];
  digitizationDetails: { engineID: number; engineName: string }[];
  qualityCheckDetails: { qualityCheckID: number; qualityCheckName: string }[];
  documentModeDetails: { modeID: number; modeDisplayName: string }[];
  lastFetched: number | null;
}

const initialState: MasterDataState = {
  languageDetails: [],
  preprocessingDetails: [],
  digitizationDetails: [],
  qualityCheckDetails: [],
  documentModeDetails: [],
  lastFetched: null
};

const masterDataSlice = createSlice({
  name: 'masterData',
  initialState,
  reducers: {
    setMasterData(state, action: PayloadAction<MasterDataState>) {
      state.languageDetails = action.payload.languageDetails;
      state.preprocessingDetails = action.payload.preprocessingDetails;
      state.digitizationDetails = action.payload.digitizationDetails;
      state.qualityCheckDetails = action.payload.qualityCheckDetails;
      state.documentModeDetails = action.payload.documentModeDetails;
      state.lastFetched = action.payload.lastFetched;
    }
  }
});

export const { setMasterData } = masterDataSlice.actions;

export default masterDataSlice.reducer;
